const ValidationsViewMessages = {
  validatePictures: 'validate-pictures',
  diagnose: 'diagnose',

}

export default ValidationsViewMessages
